import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const NavigateRightUpOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function NavigateRightUpOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M19.8 2.985c.32 0 .62.12.85.35.32.32.43.81.28 1.24l-5.5 15.88c-.04.12-.11.22-.19.31-.16.16-.35.24-.57.24-.29 0-.68-.16-.8-.6l-1.91-6.99-.3-1.1-1.1-.3-6.99-1.91a.788.788 0 0 1-.57-.58c-.05-.17-.08-.5.21-.79.09-.09.19-.15.31-.19l15.88-5.5c.13-.04.26-.07.39-.07m.01-1.99c-.35 0-.7.06-1.04.18L2.88 6.655c-.4.14-.77.37-1.07.67-1.53 1.53-.84 4.14 1.25 4.71l6.99 1.91 1.91 6.99c.36 1.32 1.53 2.08 2.73 2.08.7 0 1.42-.26 1.98-.83.3-.3.53-.67.67-1.07l5.5-15.88c.4-1.16.11-2.44-.76-3.3-.61-.61-1.43-.94-2.26-.94l-.02-.01Z" fill="currentColor" />
    </svg>;
}) as ForwardedIconComponent);
export default NavigateRightUpOutlined;